
import React from 'react';

//import Dashboard from '../components/Dashboard';
import LoginForm from '../components/LoginForm';


const LoginPage = () => {
  return (
    <div>
       <LoginForm /> 
      {/* <Dashboard/> */}
  
    </div>
  );
};

export default LoginPage;
